export interface BrandStarProps {
  size?: number;
  className?: string;
  spin?: boolean;
  color?: string;
}

export function BrandStar({
  size = 18,
  className = '',
  spin = false,
  color,
}: BrandStarProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color || 'currentColor'}
      xmlns="http://www.w3.org/2000/svg"
      className={`inline-block flex-shrink-0 align-middle ${
        spin ? 'animate-brand-spin' : ''
      } ${className}`}
      aria-hidden="true"
    >
      <path d="M12 2.25C12.5523 2.25 13 2.69772 13 3.25V9.33579L17.3033 5.03248C17.6938 4.64196 18.327 4.64196 18.7175 5.03248C19.108 5.42301 19.108 6.05617 18.7175 6.4467L14.4142 10.75H20.5C21.0523 10.75 21.5 11.1977 21.5 11.75C21.5 12.3023 21.0523 12.75 20.5 12.75H14.4142L18.7175 17.0533C19.108 17.4438 19.108 18.077 18.7175 18.4675C18.327 18.858 17.6938 18.858 17.3033 18.4675L13 14.1642V20.25C13 20.8023 12.5523 21.25 12 21.25C11.4477 21.25 11 20.8023 11 20.25V14.1642L6.6967 18.4675C6.30617 18.858 5.67301 18.858 5.28248 18.4675C4.89196 18.077 4.89196 17.4438 5.28248 17.0533L9.58579 12.75H3.5C2.94772 12.75 2.5 12.3023 2.5 11.75C2.5 11.1977 2.94772 10.75 3.5 10.75H9.58579L5.28248 6.4467C4.89196 6.05617 4.89196 5.42301 5.28248 5.03248C5.67301 4.64196 6.30617 4.64196 6.6967 5.03248L11 9.33579V3.25C11 2.69772 11.4477 2.25 12 2.25Z" />
    </svg>
  );
}
